import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Button } from '@dojo/widgets/button';
import { Radio } from '@dojo/widgets/radio';
import { quizPatternChangeProcess, userstate, createNlsMiddleware } from 'lcc-state';
import { quizidChange, quizstate } from '../support/state';
import css from '../css/quizfolder.m.css';
const nls = createNlsMiddleware('quiz');
const factory = create({ icache, nls, theme, quizstate, userstate }).properties();
export const WhichPath = factory(({ middleware: { icache, nls, theme, quizstate, userstate }, properties }) => {
    const { store, quizpatterns, topicid } = properties();
    quizstate.setStore(store);
    const { isPlaceholder, messages: { select_one, select: selectText } } = nls();
    if (isPlaceholder) {
        return null;
    }
    const choice = icache.get('choice');
    const values = quizpatterns ? Object.keys(quizpatterns).sort() : [];
    const radios = values.map((value) => {
        return w(Radio, {
            key: value,
            checked: choice === value,
            value,
            name: 'quiz-select',
            onValue: (checked) => {
                checked && icache.set('choice', value);
            }
        }, [{ label: quizpatterns[value] }]);
    });
    const themeCss = theme.classes(css);
    return v('div', { key: 'select-pattern' }, [
        v('fieldset', {}, [v('legend', {}, [select_one]), ...radios]),
        choice &&
            v('div', { classes: [themeCss.select] }, [
                w(Button, {
                    onClick: () => {
                        userstate.run(quizPatternChangeProcess)({ quizPattern: choice });
                        quizstate.run(quizidChange)({ quizid: `${topicid}-${choice}` });
                    }
                }, [selectText])
            ])
    ]);
});
